import ImageWebp from "../../layout/ImageWebp/ImageWebp";
import List from "../../layout/List/List";

import {
  installmentImage,
  installmentWebpImage,
} from "../../../assets/images";

import styles from "./InstallmentPlanConditions.module.scss";

const lists = [
  {
    title: "Warunki pożyczki",
    list: [
      "Nie interesują nas Twoje dochody i wydatki",
      "Nie potrzebujemy zeznań podatkowych",
      "Nie potrzebujemy wyciągów bankowych",
      "Wystarczy jeden dokument tożsamości",
      "Nie mamy do czynienia z rejestrami, bo nawet nie mamy do nich dostępu.",
      "Kredyt udzielany jest przez bezpośredniego właściciela lub dewelopera, naszego partnera, a nie przez bank.",
      "Możesz również ubiegać się o kredyt w swoim banku, ale pamiętaj, że bank chce poręczyć nieruchomość, która znajduje się na terytorium kraju Twojego banku, czyli w miejscu, w którym mieszkasz.",
      "Czy masz zajęcia nieruchomości, długi? Został nam całkowicie skradziony, to nie nasz problem",
    ],
  },
  {
    title: "Informacje prawne i gwarancje",
    list: [
      "Nieruchomość jest Twoją własnością od razu po podpisaniu umowy agencyjnej, możesz z niej korzystać, możesz ją wynająć.",
      "Nieruchomość jest własnością sprzedającego do momentu zapłaty ostatniej raty.",
      "Nie ma możliwości wpisu zastawu do rejestru.",
      "Nie trzeba się martwić, ponieważ właściciele mieszkań z możliwością spradzay na raty to bardzo bogate firmy dysponujące majątkiem sięgającym kilku milionów euro.",
      "Wszystko poparte jest prawnymi i zweryfikowanymi podpisami na umowie kupna-sprzedaży, prowizją.",
      "Oprocentowanie dewelopera wynosi od 5,2% do 9,7% w skali roku.",
      "Wpłata zadatku zgodnie z umową, każdy ma możliwość zakupu mieszkania na raty (minimum 5000 euro) kosztem amortyzacji wyposażenia mieszkania.",
    ],
  },
  {
    title: "Przykład planu ratalnego",
    list: [
      "Opłata wstępna 10%, reszta w ciągu 1-7 lat, w wyjątkowych przypadkach 10 lat w przypadku droższych.",
      "Lub 10% zaliczki przy podpisaniu, następnie 3 x 10% kwartalnie, pozostałe 60% można podzielić na płatności miesięczne lub kwartalne w okresie od jednego do siedmiu lat.",
      "Nieruchomość możesz spłacić wcześniej w dowolnym momencie bez kar, a nawet zostaną Ci umorzone odsetki za kolejny okres.",
      "Lub 30% zaliczki, a pozostałe 70% przez okres od 1 do 7 lat, w wyjątkowych przypadkach przez 10 lat.",
      "Zawsze możemy obliczyć wysokość wkładu za konkretną, wybraną nieruchomość.",
      "Nawet jeśli posiadasz nieruchomość na raty, możesz ją sprzedać za naszym pośrednictwem w dowolnym momencie i z zyskiem po wartości rynkowej lub pozostawić ratę innemu klientowi, oczywiście z odpowiednią odprawą rynkową.",
    ],
  },
];

const InstallmentPlanConditions = () => {
  return (
    <section className={`container ${styles.installmentPlanConditions}`}>      
        <h2 className={`titleH2 ${styles.installmentPlanConditions__title}`}>
          Warunki uzyskania mieszkania na raty
        </h2>
        <h4 className={styles.installmentPlanConditions__subtitle}>
          Warunki są bardzo proste
        </h4>      
      <div className={styles.installmentPlanConditions__lists}>
        {lists.map((item, index) => (
          <List title={item.title} list={item.list} key={index} />
        ))}
      <div className={styles.installmentPlanConditions__installmentImgWrapper}> 
        <ImageWebp
          src={installmentImage}
          srcSet={installmentWebpImage}
          alt="Installment"
          className={styles.installmentPlanConditions__installmentImg}
        />
        </div>
      </div>
    </section>
  );
};

export default InstallmentPlanConditions;
